export default __webpack_public_path__ + "static/media/products.a571744c.svg";